import AnnotationCanvasLegend from './AnnotationCanvasLegend';

export default AnnotationCanvasLegend;
